import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { registerGsap } from './motion/registerGsap'
import './styles/tokens.css'
import './styles/reset.css'
import './styles/global.css'
import './styles/responsive.css'
import './styles/motion.css'

registerGsap()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element was not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
